const isGridSection = (
  s: PerformanceBoardTypes.SlideOut.SlideOutSection,
): s is PerformanceBoardTypes.SlideOut.GridSection => {
  return s.sectionType === 'Simple Grid';
};

export default isGridSection;
